import React from 'react';
import InfoIcon from "../../resources/common/exclamation_circle.png";
import './Modal.css';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
}

const ConfirmModal: React.FC<ModalProps> = ({ isOpen, onClose, onConfirm, title, message }) => {
    if (!isOpen) return null;

    return (
        <div className="ModalPanel">
            <div className="ModalContent">
                <div className="ModalTitle">
                    <span><img src={InfoIcon} alt="info" style={{ width: '22px', paddingRight: '16px' }} /></span>
                    <span>{title}</span>
                </div>
                <div className="ModalMessage">{message}</div>
                <div className="ModalButtons">
                    <button onClick={onClose} className="ModalCancelButton">Cancel</button>
                    <button onClick={onConfirm} className="ModalConfirmButton">Confirm</button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmModal;
